export const matsushimaLogoMotion = {
  totalDurationMs: 3200,
  ids: {
    root: "ma-logo-root",
    vehicle: "ma-vehicle",
    bedLine: "ma-bed-line",
    rearWheel: "ma-wheel-rear",
    frontWheel: "ma-wheel-front",
    introCab: "ma-intro-cab",
    introWheel: "ma-intro-wheel",
    crane: "ma-crane",
    cable: "ma-cable",
    hook: "ma-hook",
    craneEmphasis: "ma-crane-emphasis",
    wordmark: "ma-wordmark",
    tagline: "ma-tagline",
  },
  // Geometry is authored in the 960×260 SVG coordinate system and scaled at runtime.
  distance: {
    sceneEntrySvgUnits: 1040,
    sceneSettleSvgUnits: -5,
    movingWheelTravelSvgUnits: 398,
    craneLowerAngleDeg: 44,
    cranePivot: { x: 736, y: 171 },
    craneTip: { x: 855, y: 52 },
  },
  // Enter slowly, settle briefly, then lower and raise the fixed-length load.
  timing: {
    sceneEntry: { delay: 0, duration: 1450 },
    craneLowerStartMs: 1475,
    craneLowerEndMs: 1825,
    liftStartMs: 1900,
    liftEndMs: 2750,
  },
  easing: {
    sceneEntry: "cubic-bezier(0.2, 0.65, 0.2, 1)",
    craneLower: "cubic-bezier(0.42, 0, 0.58, 1)",
    lift: "cubic-bezier(0.18, 0.72, 0.22, 1)",
  },
} as const;
